export enum TipoVisualizacaoSiloApiEnum {
    ISOMETRICVIEW = 0,
    PLAINVIEW = 1,
}
